import React from 'react';

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-card/20 backdrop-blur-sm">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground">
            Real Results from Real Customers
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Neevii is new — and growing fast. Our early adopters are helping us shape the future of AI accounting.
          </p>
          <p className="text-muted-foreground/80">
            Be one of the first to join and leave your mark.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-brand-accent/60 via-brand-accent/15 to-transparent blur-xl opacity-70 pointer-events-none" />
          <div className="relative">
            <div className="relative bg-card/70 backdrop-blur-md border border-brand-accent/30 rounded-3xl px-8 lg:px-12 py-12 shadow-[0_10px_28px_rgba(30,41,59,0.14)]">
              <div className="text-center space-y-4">
                <h3 className="text-2xl lg:text-3xl font-semibold text-foreground">
                  Neevii is new — and growing fast.
                </h3>
                <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                  Our early adopters are guiding product direction, automation workflows, and Open Banking rollout. Join the founding cohort and help us build the future of AI accounting.
                </p>
                <p className="text-sm uppercase tracking-wide text-muted-foreground/80">
                  Limited early access • Shaping product with us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;